import { memo } from "react";

function JitterPlot() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none">
      <path d="M2.625 0.5V21.375H23.5V23.625H0.375V0.5H2.625Z" fill="currentColor" />
      <path
        d="M6.5 19C7.8807 19 9 17.8807 9 16.5C9 15.1193 7.8807 14 6.5 14C5.11928 14 4 15.1193 4 16.5C4 17.8807 5.11928 19 6.5 19Z"
        fill="currentColor"
      />
      <path
        d="M8.5 13C9.8807 13 11 11.8807 11 10.5C11 9.11929 9.8807 8 8.5 8C7.11928 8 6 9.11929 6 10.5C6 11.8807 7.11928 13 8.5 13Z"
        fill="currentColor"
      />
      <path
        d="M12.5 17C13.8807 17 15 15.8807 15 14.5C15 13.1193 13.8807 12 12.5 12C11.1193 12 10 13.1193 10 14.5C10 15.8807 11.1193 17 12.5 17Z"
        fill="currentColor"
      />
      <path
        d="M14.5 11C15.8807 11 17 9.88071 17 8.5C17 7.11929 15.8807 6 14.5 6C13.1193 6 12 7.11929 12 8.5C12 9.88071 13.1193 11 14.5 11Z"
        fill="currentColor"
      />
      <path
        d="M21.5 11C22.8807 11 24 9.88071 24 8.49999C24 7.11929 22.8807 6 21.5 6C20.1193 6 19 7.11929 19 8.49999C19 9.88071 20.1193 11 21.5 11Z"
        fill="currentColor"
      />
      <path
        d="M18.5 16C19.8807 16 21 14.8807 21 13.5C21 12.1193 19.8807 11 18.5 11C17.1193 11 16 12.1193 16 13.5C16 14.8807 17.1193 16 18.5 16Z"
        fill="currentColor"
      />
      <path
        d="M18.5 6C19.8807 6 21 4.88071 21 3.5C21 2.11929 19.8807 1 18.5 1C17.1193 1 16 2.11929 16 3.5C16 4.88071 17.1193 6 18.5 6Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(JitterPlot);
